<script>
export default {
  name: 'ChaileaseContractPrint3',
  props: {
    item: Object,
  }
};
</script>

<template>
  <div class="wrapper" v-if="item">
    <div class="page page3">
      <div class="div1">
        <table>
          <tr>
            <td colspan="2" height="30">{{ item.customer.memberId }}</td>
          </tr>
          <tr>
            <td width="35" height="40"></td>
            <td>{{ item.customer.name }}</td>
          </tr>
        </table>
      </div><!--/.div1-->
      <div class="div2">
        <table>
          <tr>
            <td width="420" valign="bottom" height="31">{{ item.customer.name }} </td>
            <td valign="top">乙</td>
          </tr>
        </table>
      </div><!--/.div2-->
      <div class="div3">
        <table>
          <tr>
            <td width="50">{{ item.applyDate.year }}</td>
            <td width="55">{{ item.applyDate.month }}  </td>
            <td width="55">{{ item.applyDate.day }}  </td>
          </tr>
          <tr>
            <td>{{ item.applyDate.year }}</td>
            <td>{{ item.applyDate.month }} </td>
            <td>{{ item.applyDate.day }}  </td>
          </tr>
        </table>
      </div><!--/.div3-->
      <div class="div4">
        <table>
          <tr>
            <td width="75">普通重型 </td>
            <td width="76">{{item.laonhfcInfo.carId}}</td>
            <td width="118">{{ item.laonhfcInfo.name }}</td>
            <td width="85">{{ item.laonhfcInfo.vendor }}</td>
            <td width="70">{{ item.laonhfcInfo.manufactureDate }}</td>
            <td width="">{{ item.laonhfcInfo.name }}</td>
          </tr>
          <tr>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div><!--/.div4-->
      <div class="div5">
        {{ item.vendor.totalPrice }}
      </div><!--/.div5-->
      <div class="div6">
        <table>
          <tr>
            <td width="">{{ item.applyDate.year }}/{{ item.applyDate.month }}/{{ item.applyDate.day }}  </td>
          </tr>
          <tr>
            <td>{{ item.customer.home.residencePost }}{{ item.customer.home.residenceCity }}{{ item.customer.home.residenceArea }}{{ item.customer.home.residenceAddress }}</td>
          </tr>
          <tr>
            <td>{{ item.customer.memberId }}</td>
          </tr>
        </table>
      </div><!--/.div6-->
      <div class="div7">
        <table>
          <tr>
            <td width="">{{ item.applyDate.year }}/{{ item.applyDate.month }}/{{ item.applyDate.day }}  </td>
          </tr>
          <tr>
            <td>{{ item.customer.home.residencePost }}{{ item.customer.home.residenceCity }}{{ item.customer.home.residenceArea }}{{ item.customer.home.residenceAddress }}</td>
          </tr>
          <tr>
            <td>{{ item.customer.memberId }}</td>

          </tr>
        </table>
      </div><!--/.div7-->
    </div><!--/.page-->
  </div><!--/.wrapper-->
</template>

<style scoped>
html,
body {
  height: 100%;
}

body {

}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  position: relative;
  width: 210mm;
  height: 297mm;
  margin: 0mm auto;
  border: 1px #D3D3D3 solid;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  font-family: Arial, "黑體-繁", "微軟正黑體", "Microsoft JhengHei", "新細明體", Helvetica, sans-serif;
  color: #0505da !important;
  font-weight: bold;
}

/* .page3 {
    background-image: url(images/中租掃描文件-設定文件申請書.jpg);
    background-size: cover;
} */

@media print {
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    box-shadow: initial;
    page-break-after: always;
  }

  .page3 {
    background-image: none;
    background-size: none;
  }
}

.wrapper {
  position: relative;
  margin: 0 auto;
  width: 100%;
  background: #fff;
  font-family: Arial, "黑體-繁", "微軟正黑體", "Microsoft JhengHei", "新細明體", Helvetica, sans-serif;
  font-size: 12px;
  padding: 0;
  margin: 0;
  font-size: 14px;
  color: #0505da !important;
  font-weight: bold;

}

table {
  width: 100%;
  margin: 0;
}

table td {
  padding: 0;
}

/*區塊*/
.div1 {
  position: absolute;
  top: 21mm;
  left: 35mm;
  width: 100%;
}

.div2 {
  position: absolute;
  top: 50mm;
  left: 33mm;
  width: 100%;
}

.div3 {
  position: absolute;
  top: 63.5mm;
  left: 147mm;
  text-align: center;
}

.div4 {
  position: absolute;
  top: 78.5mm;
  left: 25mm;
  font-size: 13px;
  line-height: 1.4;
  text-align: center;

}

.div5 {
  position: absolute;
  top: 134mm;
  left: 85mm;
  text-align: center;
  display: table;
  width: 10mm;
}

.div6 {
  position: absolute;
  bottom: 116.5mm;
  left: 108mm;
  font-size: 11px;
  line-height: 1;
}

.div7 {
  position: absolute;
  bottom: 71mm;
  left: 108mm;
  font-size: 11px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/ChaileaseContractPrint3.vue